import Crud from '../views/Procedure/Crud'
import Entity from '../views/Procedure/Add'
import View from '../views/Procedure/View'
let routes = {
    path: '/procedure',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/procedures/add',
            name: 'Newprocedure',
            component: Entity,
            meta: {
                pageTitle: 'Procedimentos',
                breadcrumb: [
                    {
                        text: 'Procedimentos',
                        active: false,
                        to: '/procedures',
                    },
                    {
                        text: 'Adicionar Procedimento',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/procedures/edit/:id?',
            name: 'Editprocedure',
            component: Entity,
            meta: {
                pageTitle: 'Procedimentos',
                breadcrumb: [
                    {
                        text: 'Procedimentos',
                        active: false,
                        to: '/procedures',
                    },
                    {
                        text: 'Editar Procedimento',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/procedures',
            name: 'list-procedure',
            component: Crud,
            meta: {
                pageTitle: 'Procedimentos',
                breadcrumb: [
                    {
                        text: 'Procedimentos',
                        active: true,
                    },
                ],
            },
        },
         {
                    path: '/procedures/view/:id?',
                    name: 'viewProcudere',
                    component: View,
                    meta: {
                        pageTitle: '',
                        breadcrumb: [
                            {
                                text: 'Procedimentos',
                                active: false,
                                to: '/procedures',
                            },
                            {
                                text: 'Visualizar Procedimentos',
                                active: true,
                            }
                        ],
                    },
                },
    ]
    
};

export default routes;
